var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import * as templatesAPI from '@debbie/cortex/dist/api/templates';
import { Button, Modal } from '../..';
import TemplateSearch from './TemplateSearch';
const CopyModal = (props) => {
    const lang = useSelector((s) => s.lang);
    const [templates, setTemplates] = useState(null);
    const [loading, setLoading] = useState(false);
    return (React.createElement(Modal, { header: lang.templates.copyOtherTemplate, onToggle: props.toggleModal },
        React.createElement(TemplateSearch, { templateType: props.template.type, selectedTemplate: templates, onChange: (_templates) => __awaiter(void 0, void 0, void 0, function* () {
                setTemplates(_templates);
            }) }),
        React.createElement(Button, { disabled: !templates, loading: loading, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                try {
                    setLoading(true);
                    for (let i = 0; i < ((templates === null || templates === void 0 ? void 0 : templates.templates.length) || 0); i++) {
                        const template = templates === null || templates === void 0 ? void 0 : templates.templates[i];
                        if (!template)
                            continue;
                        yield templatesAPI.saveDraft(Object.assign(Object.assign({}, props.template), { public: undefined, html: template.html, intent: template.intent, subject: template.subject || '\n', lang: template.lang, templateTheme: template.templateTheme, isForAlternativeContact: template.isForAlternativeContact, fileName: template.fileName, text: template.text, setup: template.setup }));
                    }
                    yield props.toggleModal();
                    yield props.loadTemplate();
                }
                catch (error) {
                    console.error(error);
                    alert('Error');
                }
                setLoading(false);
            }) }, lang.templates.copy)));
};
export default CopyModal;
//# sourceMappingURL=CopyTemplateModal.js.map